import React, { useState } from "react";
import LdsButton from "../components/LdsButton";
import { saveAs } from "file-saver";
import { BootstrapAlert } from "../components/BootstrapAlert";

// services
import { getHeaders } from "../store/utils/helper";

const Certiicate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleDownloadCertificate = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process?.env?.REACT_APP_API_HOST_URL}/user/download/core_training_certificate`,
      { headers: getHeaders() }
    );

    setIsLoading(false);
    if (!response.ok) {
      setErrorMessage("Something went wrong! Please try again after sometime.");
      return false;
    }

    // Extract filename from header
    const filename = response?.headers
      ?.get("content-disposition")
      ?.split(";")
      ?.find((n) => n.includes("filename="))
      ?.replace("filename=", "")
      ?.trim();

    const blob = await response.blob();

    // Download the file
    saveAs(blob, filename);
  };

  return (
    <main>
      <section className="section">
        <div className="row">
          <div className="col-sm-12 col-md-10 col-lg-8 offset-md-2 offset-lg-2 text-center">
            <h1 className="text-uppercase b">
              Thank you for completing the core amyvid reader training program
            </h1>
            <p className="mt-4">
              Click the Download Certificate button below to receive your
              personalized certificate of completion. A copy of your certificate
              will also be sent to the email address you have provided.
            </p>
            <p>
              Add{" "}
              <span className="b blue">no-reply@amyvidreadertraining.com</span>{" "}
              to your address book to ensure you receive your certificate.
            </p>
            <div className="row">
              <BootstrapAlert variant="danger" message={errorMessage} />
              <div className="col-sm-12 col-md-6 col-lg-6 offset-lg-0 col-xl-5 offset-xl-1">
                <LdsButton
                  classes="white-button mt-3 mb-5"
                  //   href={this.props.previousLesson}
                  onClick={function navClick() {
                    window.open("/overview", "_self");
                  }}
                >
                  Reader Training Overview
                </LdsButton>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 offset-lg-0 col-xl-5 offset-xl-1">
                <LdsButton
                  disabled={isLoading}
                  classes="blue-button mt-3 mb-5"
                  onClick={handleDownloadCertificate}
                >
                  Download Certificate
                </LdsButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Certiicate;
